<template>
  <section class="maincontent py-16" :style="componentStyle" :id="sectionId">
    <v-container>
      <v-row>
        <v-col>
          <h1>{{title}}</h1>
          <p>{{text}}</p>
          <v-btn
            large
            depressed
            style="color:white"
            color="#FB6863"
            @click="onBtnClick()"
          >{{btnText}}</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>
<script>
import promotionPageMixin from '../mixins/promotion-page'
import { getInternalRoute } from '../utils/routing'
export default {
  mixins: [promotionPageMixin],
  props: {
    title: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    btnText: {
      type: String,
      default: ''
    },
        // Not used for now. Using activation-url from add-on
    btnUrl: {
      type: String,
      default: ''
    }
  },

  methods: {
    onBtnClick () {
       let url = this.btnUrl ? this.btnUrl : this.ctaUrl
      let route = getInternalRoute(url)
      if (route) {
        this.$router.push(route)
      } else if (url) {
        window.location.href = url
      }
    }
  }
}
</script>
<style scoped>
.maincontent {
  display: block;
  height: 356px;
  text-align: center;
}

.maincontent h1 {
  color: #454749;
  font-family: "Niveau Grotesk";
  font-size: 42px;
}

.maincontent p {
  color: #454749;
  font-family: "Niveau Grotesk";
  font-size: 20px;
  margin-bottom: 36px;
}

@media only screen and (max-width: 600px) {
  .maincontent {
    margin-top: 450px;
  }
}
</style>
